import { makeAutoObservable, observable } from "mobx";
import { IAPIGetListInterestTagResponseModel } from "../interfaces/IAPIListInterestTagModel";
import { ListInterestTagModel } from "../models";
import { AuthService, ListInterestTagService } from "../services";
import { IOption } from "@mindmemobile/mm-shared-global";
import { firstValueFrom } from "rxjs";

export default class ListInterestTagStore {
  @observable lists: ListInterestTagModel[] = [];
  @observable interests: ListInterestTagModel[] = [];
  @observable tags: ListInterestTagModel[] = [];
  @observable apiPending = false;

  constructor() {
    makeAutoObservable(this);
    this.loadData();
  }

  loadData(): void {
    if (this.apiPending) {
      return;
    }
    this.apiPending = true;
    ListInterestTagService.getMindMeListInterestTag(
      AuthService.authData.accountId
    ).subscribe((response) => {
      this.deserializeAPIResponse(response.result);
      this.apiPending = false;
    });
  }

  deserializeAPIResponse(data: IAPIGetListInterestTagResponseModel): void {
    this.lists =
      data?.lists?.map((l: any) => ListInterestTagModel.deserialize(l)) || [];
    this.interests =
      data?.interests?.map((l: any) => ListInterestTagModel.deserialize(l)) ||
      [];
    this.tags =
      data?.tags?.map((l: any) => ListInterestTagModel.deserialize(l)) || [];
  }

  get listOptions(): IOption[] {
    return this.lists.map((l) => ({ label: l.name, value: l.id }));
  }

  get tagOptions(): IOption[] {
    return this.tags.map((l) => ({ label: l.name, value: l.id }));
  }

  get interestOptions(): IOption[] {
    return this.interests.map((l) => ({ label: l.name, value: l.id }));
  }

  async createNew(name: string, type: string): Promise<string> {
    const response = await firstValueFrom(
      ListInterestTagService.create(AuthService.authData.accountId, name, type)
    );
    if (response.result?.id) {
      this.loadData(); 
      return response.result.id;
    }
    return "";
  }
}
